import { is3pProductKey, type ProductKeys3P } from '../constants/products';
import { type ThirdPartyConfigsBootstrap } from '../constants/schemas/3p-config';

export const isProductImpersonated: (
	product: ProductKeys3P | undefined,
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
) => boolean = (
	product: ProductKeys3P | undefined,
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
): boolean => {
	return !!(product && is3pProductKey(product)
		? thirdPartyConfigs[product]?.impersonationEnabled
		: false);
};
